import { StoreType, TAG } from '@heimdallr-sdk/types';
function getStoreIns(type) {
    var store = null;
    switch (type) {
        case StoreType.LOCAL:
            store = localStorage;
            break;
        case StoreType.SESSION:
            store = sessionStorage;
            break;
        default:
            break;
    }
    return store;
}
export function getStore(type, keyPath, needParse) {
    if (needParse === void 0) { needParse = true; }
    if (!type || !keyPath) {
        return '';
    }
    var store = getStoreIns(type);
    if (!store) {
        return '';
    }
    var result = '';
    try {
        var paths = keyPath.split('.');
        var key = paths[0];
        result = store.getItem(key);
        if (needParse) {
            result = JSON.parse(result);
            if (paths.length > 1) {
                result = paths.slice(1).reduce(function (pre, cur) { return pre[cur]; }, result);
            }
        }
    }
    catch (err) {
        console.error(TAG, err);
    }
    return result;
}
export function setStore(type, key, data) {
    if (!key) {
        return;
    }
    var store = getStoreIns(type);
    if (!store) {
        return;
    }
    store.setItem(key, JSON.stringify(data));
}
export function setCookie(key, value, days) {
    if (!key || !value || !days) {
        return;
    }
    var exp = new Date();
    exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = "".concat(key, "=").concat(encodeURIComponent(value), ";expires=").concat(exp.toUTCString());
}
export function getCookie(key) {
    if (!key) {
        return '';
    }
    var arr = document.cookie.match(new RegExp("(^| )".concat(key, "=([^;]*)(;|$)")));
    if (arr != null) {
        return decodeURIComponent(arr[2]);
    }
    else {
        return '';
    }
}
export function delCookie(key) {
    if (!key) {
        return;
    }
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(key);
    if (cval != null) {
        document.cookie = "".concat(key, "=").concat(cval, ";expires=").concat(exp.toUTCString());
    }
}
